import {
    Configuration,
    ActivityTrackerApi,
    ExpenseApi,
    ProjectFreelancerListApi,
    FreelancerInformationApi,
    ProjectFreelancerQuoteApi,
    FreelancerClientApi,
    ProjectFreelancerApi,
    ProjectTermsApi,
} from '@api';

const configuration = new Configuration({basePath: ''});

export const activityTrackerEndpoints = new ActivityTrackerApi(configuration);
export const expensesTrackerEndpoints = new ExpenseApi(configuration);
export const projectFreelancerEndpoints = new ProjectFreelancerListApi(configuration);
export const freelancerInformationEndpoints = new FreelancerInformationApi(configuration);
export const quoteEndpoints = new ProjectFreelancerQuoteApi(configuration);
export const freelancerClientInfoEndpoints = new FreelancerClientApi(configuration);
export const projectEndpoints = new ProjectFreelancerApi(configuration);
export const projectTermsEndpoints = new ProjectTermsApi(configuration);
